import { IUpdateAction } from './types';
import { AT_UPDATE } from './constants';
import { IChatGroup } from '../../../../../../../rest/effects/chats/group/types';

export const updateAction = (
    group: Partial<IChatGroup>,
): IUpdateAction => ({
    type: AT_UPDATE,
    group,
});
